var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3725 7.18821C17.6497 7.01494 17.8182 6.71088 17.8182 6.38403C17.8182 6.05693 17.6497 5.75312 17.3725 5.57985L9.78503 0.837592C9.47736 0.645607 9.08716 0.645607 8.77949 0.837592L1.19198 5.57985C0.914794 5.75312 0.746338 6.05693 0.746338 6.38403C0.746338 6.71088 0.914794 7.01494 1.19198 7.18821L8.77949 11.9302C9.08716 12.1225 9.47736 12.1225 9.78503 11.9302L17.3725 7.18821ZM3.4844 6.38403L9.2822 10.0077L15.0801 6.38403L9.2822 2.76032L3.4844 6.38403Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27991 13.8014L16.3648 9.37352C16.8086 9.0961 17.3941 9.2312 17.6715 9.67493C17.9489 10.1189 17.8139 10.7044 17.3701 10.9819L9.78274 15.7239C9.47507 15.9161 9.08475 15.9161 8.77708 15.7239L1.18969 10.9819C0.745952 10.7044 0.610872 10.1189 0.888299 9.67493C1.16572 9.2312 1.75125 9.0961 2.19499 9.37352L9.27991 13.8014Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.49172dc70d4de0891dfeec61a0440fea.svg";
export { ForwardRef as ReactComponent };